import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { Team } from '@/types/tournament.model';
import { PLAYER_FIELDS } from '../player/player-fields.config';

const TEAM_FIELDS_FULL: CompleteFieldSelector<Team> = {
  id: true,
  players: PLAYER_FIELDS.FULL,
};

export const TEAM_FIELDS = {
  FULL: TEAM_FIELDS_FULL,
} as const;
